export function Header(): string {
  const currentHash = window.location.hash || '#home';

  const navItems = [
    { label: 'Studio Hub', href: '#home' },
    { label: 'AtomixGame', href: '#games', badge: 'Games' },
    { label: 'AtomixMusics', href: '#musics', badge: 'AI Music' },
    { label: 'AtomixFilms', href: '#films', badge: 'AI Cinema' },
    { label: 'AtomixDevs', href: '#devs', badge: 'Vibe Code' },
    { label: 'About & Founder', href: '#about' },
    { label: 'Contact', href: '#contact' }
  ];

  const navHtml = navItems.map(item => {
    const isActive = currentHash === item.href;
    const activeStyle = isActive 
      ? 'color: #00f2fe; background: rgba(0, 242, 254, 0.12); border-color: rgba(0, 242, 254, 0.35);' 
      : 'color: #cbd5e1; background: transparent; border-color: transparent;';
    
    return /*html*/`
      <a href="${item.href}" 
         style="display: inline-flex; align-items: center; gap: 0.4rem; padding: 0.45rem 0.9rem; border-radius: 8px; border: 1px solid transparent; font-size: 0.9rem; font-weight: 500; text-decoration: none; transition: all 0.2s ease; ${activeStyle}"
         onmouseover="this.style.color='#00f2fe'; this.style.backgroundColor='rgba(255,255,255,0.06)'"
         onmouseout="this.style.color='${isActive ? '#00f2fe' : '#cbd5e1'}'; this.style.backgroundColor='${isActive ? 'rgba(0, 242, 254, 0.12)' : 'transparent'}'"
      >
        <span>${item.label}</span>
      </a>
    `;
  }).join('');

  return /*html*/`
    <header style="position: sticky; top: 0; z-index: 100; background: rgba(7, 8, 13, 0.85); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-bottom: 1px solid rgba(255, 255, 255, 0.08); padding: 0.85rem 0;">
      <div class="container">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
          
          <!-- Brand Logo -->
          <a href="#home" style="display: flex; align-items: center; gap: 0.75rem; text-decoration: none;">
            <div style="width: 42px; height: 42px; border-radius: 10px; background: linear-gradient(135deg, #00f2fe 0%, #a855f7 100%); display: flex; align-items: center; justify-content: center; font-weight: 900; font-size: 1.4rem; color: #07080d; box-shadow: 0 0 15px rgba(0, 242, 254, 0.5);">
              M
            </div>
            <div>
              <div style="font-size: 1.35rem; font-weight: 800; letter-spacing: -0.03em; line-height: 1.1;">
                <span style="color: #ffffff;">ATOMIX</span><span style="color: #00f2fe;">M</span>
              </div>
              <div style="font-size: 0.72rem; color: #94a3b8; letter-spacing: 0.12em; text-transform: uppercase; font-weight: 600;">
                Multimedia · Mass · AI
              </div>
            </div>
          </a>

          <!-- Navigation Links -->
          <nav style="display: flex; align-items: center; gap: 0.25rem; flex-wrap: wrap;">
            ${navHtml}
          </nav>

          <!-- Action Button -->
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <a href="https://github.com/atomixgame" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.45rem 0.9rem; font-size: 0.85rem; border-radius: 8px;">
              <sl-icon name="github" style="font-size: 1.1rem;"></sl-icon>
              <span>GitHub</span>
            </a>
          </div>

        </div>
      </div>
    </header>
  `;
}
